import './setup-jquery-global';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import registerServiceWorker from './registerServiceWorker';
import FcmBootstrap from './components/fcm/FcmBootstrap';
import axios from 'axios';
import { Provider } from 'react-redux';
import store, {persistor} from './store/index';
import {PersistGate} from 'redux-persist/es/integration/react';
import setupAxiosInterceptors from './helpers/axios-interceptor';

// Production: use /api/ (Nginx → HTTP backend). Never call https://pay.earth:7700 from the browser.
function resolveApiBase() {
  let base =
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_DEV_URL ||
    (process.env.NODE_ENV === "production" ? "/api/" : "http://localhost:7700/");

  // On pay.earth the API is always same-origin /api/ (Nginx → HTTP backend on 7700).
  if (typeof window !== "undefined") {
    const host = window.location.hostname || "";
    if (/pay\.earth$/i.test(host)) {
      return "/api/";
    }
  }

  return base.endsWith("/") ? base : `${base}/`;
}

const config = {
    apiURI: resolveApiBase(),
    googleClientId: process.env.REACT_APP_CLIENT_ID || "1014730483006-d972hbp9cjm6iesogsvdfguqm1fs57lq.apps.googleusercontent.com",
    facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID || "1051494993312282"
};

// Make config globally available
window.config = config;

axios.defaults.baseURL = config.apiURI;
setupAxiosInterceptors();
ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <FcmBootstrap />
                <App />
            </PersistGate>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerServiceWorker();
